export default {
	name: 'Terms',
	component: 'Generic',
	path: 'terms',
	meta: {
		public: true,
		api: 'terms',
		title: 'Terms'
	}
}